
import React from 'react';
import ValuePropositionHeader from './valueproposition/ValuePropositionHeader';
import ValuePropositionBackground from './valueproposition/ValuePropositionBackground';
import ValueCardsGrid from './valueproposition/ValueCardsGrid';
import BackgroundStars from './valueproposition/BackgroundStars';
import FloatingElements from './valueproposition/FloatingElements';

const ValuePropositionSection = () => {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      <ValuePropositionBackground />
      <BackgroundStars />

      <div className="container mx-auto px-4 relative z-10">
        <ValuePropositionHeader />
        <ValueCardsGrid />
        <FloatingElements />
      </div>
    </section>
  );
};

export default ValuePropositionSection;
